import React from 'react';
import styled from 'styled-components';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { AlertGroupName, IAlertState, useAlertState } from '../../hooks/useAlertState/useAlertState';
import { Alert } from '../Alert/Alert';
import { IGapSizeProps, useColumnGapCss } from '../../fundamentals/spaces/space';
import { groupByVariant } from './alertParser';
import { BaseDiv } from '../../common/BaseElements';

const Container = styled(BaseDiv)<IGapSizeProps>`
  width: 100%;
  ${useColumnGapCss()};
`;

export interface IAlertProviderProps {
  groupName: AlertGroupName;
}

const AlertsGroup: React.FC<{ alerts: IAlertState[] } & IAlertProviderProps> = ({ alerts, groupName }) => (
  <>
    {alerts.map((alert) => (
      <Alert key={alert.id} groupName={groupName} {...alert}>
        {alert.children}
      </Alert>
    ))}
  </>
);

export const AlertProvider: React.FC<IAlertProviderProps> = ({ groupName }, ...rest) => {
  const { generateTestId } = useTestId(rest, `AlertProvider`);
  const { state } = useAlertState(groupName);

  const alertGroups = state && groupByVariant(state);

  return (
    <Container gap={32} {...generateTestId()} {...rest}>
      {alertGroups?.map((alertGroup, index) => <AlertsGroup key={index} alerts={alertGroup} groupName={groupName} />)}
    </Container>
  );
};
